import i18n from 'i18nextInstance';

export const HEADERS = [{
    flex: 6,
    key: 'name',
    label: i18n.t('Recomendación')
}, {
    format: () => ({
        center: true
    }),
    key: 'percentage',
    label: '%'
}];
